import { useTranslation } from "react-i18next";

import { StatusPill as Pill, type StatusTone } from "@/components/ui/status-pill";
import type { FinancialAidStatus } from "../../types";

/**
 * Where an aid stands, for the back-office list — the SPA counterpart of the
 * Django table's Statut chip. The API sends a code; the label is localized here.
 *
 * "En attente" means the aid's links are staged for a second admin's approval, so
 * it reaches nobody yet. The SPA has no review UI to act on it (a tracked
 * cross-app gap), but showing the real state beats implying the aid is live.
 */
const TONES: Record<FinancialAidStatus, StatusTone> = {
  active: "success",
  unassociated: "warning",
  inactive: "muted",
  expired: "destructive",
  upcoming: "info",
  pending: "warning",
};

export function StatusPill({ status }: { status: FinancialAidStatus }) {
  const { t } = useTranslation();
  return (
    <Pill tone={TONES[status] ?? "muted"}>
      {t(`financialAids.admin.status.${status}`)}
    </Pill>
  );
}
